var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"agreement",class:`agreement ${_vm.marginT ? 'marginT' : ''}`,style:({ height: _vm.marginT ? 'auto !important' : `${_vm.height}px` })},[_c(_vm.type,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }